import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Modal, ModalBody, Row, Col } from "reactstrap";
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, Chip } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PndRestApi from "src/utils/pnd/PndRestApi";
import { showNotification } from "src/shared/components/Notification";
import { ERROR_MESSAGES } from "src/utils/pnd/PndConstants";

const HubAddressChangeModal = ({ modalShow, setModalShow, isTitle, hubCustomerId }) => {
    const [isAddressInfo, setAddressInfo] = useState([]);
    const [selectedPrimaryId, setSelectedPrimaryId] = useState(null);

    useEffect(() => {
        if (modalShow && hubCustomerId) {
            getHubCustomersAddressDetails();
        }
    }, [modalShow, hubCustomerId]);

    const toggle = () => setModalShow(prevState => !prevState);

    const getHubCustomersAddressDetails = async () => {
        try {
            const response = await PndRestApi.GetHubCustomerAddressBook(hubCustomerId);
            if (response.status === 200 && response.data.status === 200) {
                setAddressInfo(response.data.data);
                const primaryAddress = response.data.data.find(row => row.addressType === 1);
                if (primaryAddress) setSelectedPrimaryId(primaryAddress.id);
            } else {
                showNotification("theme-light", "ltr", `SuccessCode: ${response.data.status}`, `Message:${response.data.message}`);
            }
        } catch (error) {
            showNotification("theme-light", "ltr", "500", ERROR_MESSAGES.tryCatchError);
        }
    };

    return (
        <Modal
            isOpen={modalShow}
            toggle={toggle}
            className="theme-light ltr-support credit-memo-modal-form-ani"
            centered
            style={{ maxWidth: '900px' }}
        >
            <div className="modal__header border-bottom-0 pb-0">
                <button
                    className="lnr lnr-cross modal__close-btn"
                    aria-label="modal__close-btn"
                    type="button"
                    onClick={toggle}
                />
                <div className="d-flex align-items-center mb-1">
                    <LocationOnIcon className="text-success me-2" style={{ fontSize: '1.5rem' }} />
                    <h5 className="modal__title text-uppercase fw-bold m-0" style={{ color: "#21B368", fontSize: '1rem' }}>
                        {isTitle || "Change Address"}
                    </h5>
                </div>
            </div>
            <ModalBody className="p-3">
                <Paper elevation={0} className="border rounded overflow-hidden">
                    <div className="overflow-auto">
                        <Table size="small">
                            <TableHead>
                                <TableRow style={{ background: "#f8f9fa" }}>
                                    <TableCell className="fw-bold py-2" style={{ fontSize: '0.8rem' }}>Type</TableCell>
                                    <TableCell className="fw-bold py-2" style={{ fontSize: '0.8rem' }}>Customer</TableCell>
                                    <TableCell className="fw-bold py-2" style={{ fontSize: '0.8rem' }}>Code</TableCell>
                                    <TableCell className="fw-bold py-2" style={{ fontSize: '0.8rem' }}>Title</TableCell>
                                    <TableCell className="fw-bold py-2" style={{ fontSize: '0.8rem' }}>Address</TableCell>
                                    <TableCell className="fw-bold py-2" style={{ fontSize: '0.8rem' }}>Mobile</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {isAddressInfo && isAddressInfo.length > 0 ? (
                                    isAddressInfo.map((row, idx) => (
                                        <TableRow key={idx} hover>
                                            <TableCell className="py-2">
                                                <div className="d-flex align-items-center">
                                                    <input
                                                        className="form-check-input me-2 mt-0"
                                                        type="radio"
                                                        name="primary-address"
                                                        checked={selectedPrimaryId === row.id}
                                                        readOnly
                                                        style={{ cursor: 'pointer', width: '16px', height: '16px' }}
                                                    />
                                                    <Chip
                                                        label={row.addressType === 1 ? "Primary" : "Secondary"}
                                                        size="small"
                                                        color={row.addressType === 1 ? "success" : "warning"}
                                                        style={{ fontSize: '0.65rem', height: '18px' }}
                                                    />
                                                </div>
                                            </TableCell>
                                            <TableCell className="py-2" style={{ fontSize: '0.8rem' }}>{row.customerName}</TableCell>
                                            <TableCell className="py-2" style={{ fontSize: '0.8rem' }}>{row.customerCode}</TableCell>
                                            <TableCell className="py-2" style={{ fontSize: '0.8rem' }}>{row.addressBookName}</TableCell>
                                            <TableCell className="py-2" style={{ fontSize: '0.8rem', maxWidth: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                {row.address}
                                            </TableCell>
                                            <TableCell className="py-2" style={{ fontSize: '0.8rem' }}>{row.mobileNo}</TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={6} className="text-center py-4 text-muted">No address information available</TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </div>
                </Paper>
            </ModalBody>
        </Modal>
    );
};

export default connect()(HubAddressChangeModal);
